import React from 'react'
import { useDispatch } from 'react-redux'

import { setCurrentDataOutbound } from 'redux/outbound/actions'
import { getStaticImage } from 'utils/statics'

const ChannelIconButton = ({ type, name, contact, toggle }) => {
  const dispatch = useDispatch()

  const channel = type === 'email'
    ? 'chatmail'
    : type === 'phone'
      ? contact.wa_id ? 'whatsapp' : 'sms'
      : ''

  const outboundData =  { channel, to: { chips: [{ isValid: true }] } }
  if (name) outboundData.to.chips[0].name = name
  if (contact.id) {
    outboundData.to.chips[0].id = contact.id
    if (contact.phone) outboundData.to.chips[0].phone = contact.phone
    if (contact.email) outboundData.to.chips[0].email = contact.email
  } else {
    outboundData.to.chips[0].value = contact.phone || contact.email
  }

  return (
    <button
      className='side-popup-contact__channel-icon-btn'
      onClick={() => {
        dispatch(setCurrentDataOutbound({ outboundCurrentData: outboundData }))
        toggle()
      }}
    >
      <figure>
        <img src={getStaticImage(`/channels/orange-brand/${channel}-icon.svg`)} alt={channel} />
      </figure>
    </button>
  )
}

export const ParsedContacts = ({ type, name, data, toggle }) => (
  <ul className='side-popup-contact__contacts-list'>
    {type === 'address' ? (
      data.map((it, index) => {
        const address = []
        if (it.street) address.push(it.street)
        if (it.city) address.push(it.city)
        if (it.state) address.push(it.state)
        return (
          <li key={index}>
            <p>{address.join(', ')}</p>
            {
              it.type
                ? <span>{`(${it.type})`}</span>
                : null
            }
          </li>
        )
      })
    ) : null}
    {['email', 'phone'].includes(type) ? (
      data.map((it, index) => (
        <li key={index}>
          <p>{it.email || `${it.phone}`}</p>
          {
            it.type
              ? <span>{`(${it.type})`}</span>
              : null
          }
          <ChannelIconButton type={type} name={name} contact={it} toggle={toggle} />
        </li>
      ))
    ) : null}
    {type === 'url' ? (
      data.map((it, index) => (
        <li key={index}>
          <a href={it.url} target='_blank' rel='noopener noreferrer'>{it.url}</a>
          {
            it.type
              ? <span>{`(${it.type})`}</span>
              : null
          }
        </li>
      ))
    ) : null}
  </ul>
)
